export const AppCycles = Object.freeze({
  BV_PENDING: 'aa25',
  PLAID_UPDATE_MODE_REQD: 'aa32',
  PLAID_NEW_ITEM_REQD: 'aa33',
  PLAID_ASSET_REPORT_REFRESH_PENDING: 'aa_11',
  COMPLETE_APPLICATION: 'aa11'
})